import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createClient } from "@supabase/supabase-js";
import YourCurationsPage from "./YourCurationsPage";
import ExplorePage from "./ExplorePage";
import UserRepository from "../../repository/UserRepository";
import { useRef } from "react";
import SearchPage from "./SearchPage";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default function HomePage({tab, analytics}) {

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const [currentPage, setCurrentPage] = useState(
        tab == "yours" ? 2 : (tab == "search" ? 0 : 1)
    )
    const mainListRef = useRef()
    const [userProfile, setUserProfile] = useState(null)
    const [homeLoadingText, setHomeLoadingText] = useState(null)
    const [title, setTitle] = useState("Roambear")

    const navigate = useNavigate()

    useEffect(() => {
        async function getUserProfile() {
            const {
              data: { user },
            } = await supabase.auth.getUser()
            if (user == null) {
              navigate("/login", {replace: true})
            } else {
              const userRepository = new UserRepository()
              try {
                  const profileResponse = await userRepository.getUserProfile()
                  console.log(profileResponse)
                  onUserProfileLoaded(profileResponse)
              } catch(e) {
                  console.log(`get profile error ${e.response.status}`)
                  navigate("/signup/completion", {replace: true})
              }
            }
          }
          getUserProfile()
      }, [])

    function bottomNavigationItemClicked(index) {
        setCurrentPage(index)
        mainListRef.current.scrollTop = 0
        if (index == 1) {
            window.history.pushState(null, null, `/explore`)
        } else if(index == 2) {
            window.history.pushState(null, null, `/yours`)
        } else if(index == 0) {
          window.history.pushState(null, null, `/search`)
      }
    }

    window.addEventListener('popstate', function(_) {
        console.log(`href is ${window.location.href}`)
        if (window.location.href.includes("yours")) {
            setCurrentPage(2)
        } else if (window.location.href.includes("search")) {
            setCurrentPage(0)
        } else {
            setCurrentPage(1)
        }
    })

    function onBackPressed() {}

    async function onSignOutClick() {
        setHomeLoadingText("Logging out ...")
        const { error } = await supabase.auth.signOut(
            {
                scope: "local"
            }
        )
        navigate("/login")
    }

    function onUserProfileLoaded(profile) {
        setUserProfile(profile)
    }

    function onTitleChange(title) {
        setTitle(title)
    }

    return (
        <div className="overflow-y-hidden h-full" ref={mainListRef}>
            <div className="h-full">
                {
                    currentPage == 0 && <SearchPage 
                    analytics={analytics} 
                    userProfile={userProfile} 
                    onSignOutClick={onSignOutClick} 
                    onRequestToScrollToTop={() => { mainListRef.current.scrollTop = 0 }}
                    onExploreClick={() => {
                        setCurrentPage(1)
                        window.history.pushState(null, null, `/explore`)
                    }}
                    onCollectionClick={() => {
                        setCurrentPage(2)
                        window.history.pushState(null, null, `/yours`)
                    }}/>
                }
                {
                    currentPage == 1 && <ExplorePage 
                    analytics={analytics} 
                    userProfile={userProfile} 
                    onSignOutClick={onSignOutClick} 
                    onRequestToScrollToTop={() => { mainListRef.current.scrollTop = 0 }}
                    onSearchClick={() => {
                        setCurrentPage(0)
                        window.history.pushState(null, null, `/search`)
                    }}
                    onCollectionClick={() => {
                        setCurrentPage(2)
                        window.history.pushState(null, null, `/yours`)
                    }}
                    />
                }
                {
                    currentPage == 2 && <YourCurationsPage 
                    analytics={analytics} 
                    userProfile={userProfile} 
                    onSignOutClick={onSignOutClick} 
                    onTitleChange={() => {}}
                    onExploreClick={() => {
                        setCurrentPage(1)
                        window.history.pushState(null, null, `/explore`)
                    }}
                    onSearchClick={() => {
                        setCurrentPage(0)
                        window.history.pushState(null, null, `/search`)
                    }}/>
                }
                {
              //   <div className="btm-nav bg-neutral">
              //   <button className={`${ currentPage == 0 ? "active bg-neutral": "" }`}  onClick={() => {bottomNavigationItemClicked(0)}}>
              //     {
              //       currentPage != 0 && <svg className="fill-neutral-content w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              //       <path fill-rule="evenodd" d="M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M17.9842695,7.39078625 C18.1985588,6.64477525 17.4973604,5.9435768 16.7513494,6.1578661 L16.6494246,6.19284365 L9.57835679,9.02127078 L9.47282273,9.07079854 C9.30957453,9.15937167 9.17428758,9.29167162 9.08209683,9.45256344 L9.02127078,9.57835679 L6.19284365,16.6494246 L6.1578661,16.7513494 C5.9435768,17.4973604 6.64477525,18.1985588 7.39078625,17.9842695 L7.49271102,17.949292 L14.5637788,15.1208648 L14.6693129,15.0713371 C14.8325611,14.982764 14.967848,14.850464 15.0600388,14.6895722 L15.1208648,14.5637788 L17.949292,7.49271102 L17.9842695,7.39078625 Z M12,10 C13.1045695,10 14,10.8954305 14,12 C14,13.1045695 13.1045695,14 12,14 C10.8954305,14 10,13.1045695 10,12 C10,10.8954305 10.8954305,10 12,10 Z"/>
              //       </svg>
              //     }
              //     {
              //       currentPage == 0 && <span className="w-5 h-5 text-base">🧭</span>
              //     }
              //     <span className="btm-nav-label">Explore</span>
              //   </button>
              //   <button className={`${ currentPage == 1 ? "active bg-neutral": "" }`}  onClick={() => {bottomNavigationItemClicked(1)}}>
              //     {
              //       currentPage != 1 && <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              //       <path className="stroke-neutral-content" d="M16.6725 16.6412L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              //       </svg>
              //     }
              //     {
              //       currentPage == 1 && <span className="w-5 h-5 text-base">🔍</span>
              //     }
              //     <span className="btm-nav-label">Search</span>
              //   </button>
              //   <button className={`${ currentPage == 2 ? "active bg-neutral": "" }`} onClick={() => {bottomNavigationItemClicked(2)}}>
              //     { currentPage != 2 && <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              //       <path className="fill-neutral-content" fill-rule="evenodd" clip-rule="evenodd" d="M5.36129 3.46995C6.03579 3.16081 6.76287 3 7.50002 3C8.23718 3 8.96425 3.16081 9.63875 3.46995C10.3129 3.77893 10.9185 4.22861 11.4239 4.78788C11.7322 5.12902 12.2678 5.12902 12.5761 4.78788C13.5979 3.65726 15.0068 3.00001 16.5 3.00001C17.9932 3.00001 19.4021 3.65726 20.4239 4.78788C21.4427 5.91515 22 7.42425 22 8.9792C22 10.5342 21.4427 12.0433 20.4239 13.1705L14.2257 20.0287C13.0346 21.3467 10.9654 21.3467 9.77429 20.0287L3.57613 13.1705C3.07086 12.6115 2.67474 11.9531 2.40602 11.2353C2.13731 10.5175 2 9.75113 2 8.9792C2 8.20728 2.13731 7.44094 2.40602 6.72315C2.67474 6.00531 3.07086 5.34694 3.57613 4.78788C4.08157 4.22861 4.68716 3.77893 5.36129 3.46995Z"/>
              //     </svg>}
              //     {
              //       currentPage == 2 && <span className="w-5 h-5 text-base">❤️</span>
              //     }
              //     <span className="btm-nav-label">Yours</span>
              //   </button>
              // </div>
                }
            </div>
            {/* <div className="pb-16">
            <CoorayFooter />
            </div> */}
            {homeLoadingText &&
            <div className='w-full h-screen fixed top-0 flex flex-col items-center justify-center backdrop-blur-sm bg-base-100/30'>
                <div className="loading loading-infinity loading-lg"></div>
                <div className='font-normal text-base-content mt-2'>{homeLoadingText}</div>
            </div>
            }
            {/* {
                <FeedbackButton modifier={"bottom-[4rem]"}/>
            } */}
        </div>
    )
}
